import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { shippingLabelStatus } from './constants'

const ShippingLabelStatusSelector = ({ onChange, value }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      value={value}
      label={t('Estado etiquetas de devolución')}
      handleChange={e => onChange(e.target.value)}
      menuItems={shippingLabelStatus.map(dm => ({ label: t(dm.label), value: dm.value }))}
    />
  )
}

export default ShippingLabelStatusSelector
